import { render } from "./SuccessRecoverPassword.vue?vue&type=template&id=1e567aea&scoped=true"
import script from "./SuccessRecoverPassword.vue?vue&type=script&lang=js"
export * from "./SuccessRecoverPassword.vue?vue&type=script&lang=js"

import "./SuccessRecoverPassword.vue?vue&type=style&index=0&id=1e567aea&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e567aea"]])

export default __exports__